<template>
    <b-modal :no-close-on-backdrop="true" v-if='thread && thread.thread_provider' @hidden="shown = false" @shown='initCopySelect' centered ref="copyDialog" :title="capitalise(autobrand('translations.request_details'))" size="xl" header-class='scroller-header-shadow' footer-class="list-footer">
    <!-- <b-modal :no-close-on-backdrop="true" v-if='thread && thread.thread_provider' v-model='shown' @shown='initCopySelect' centered ref="copyDialog" :title="$t('translations.request_details')" size="xl" body-class="dialog-body-outer-scroll"> -->
        <div class='d-flex flex-column h-100'>
            <div class='p-2 flex-grow-1-scroll h-100'>
            
                <local-error v-bind:errors='errors' v-bind:inline='["codes.*", "blood_pressures.*"]'></local-error>
                
                <p v-if='mutable_copy_message' class="alert alert-warning mb-2">{{ $t(mutable_copy_message) }}</p>
                <template v-if="!thread.archived">
                    <p v-if='
                            originating_provider_has_user_record_system_integration 
                            && !can_copy_to_record_system' 
                        class="alert alert-warning">{{ autobrand("translations.mrs_no_nhs_number_originator") }}</p>
                    <p v-else-if='
                            has_user_record_system_integration 
                            && !can_copy_to_record_system' 
                        class="alert alert-warning">{{ autobrand("translations.mrs_no_nhs_number") }}</p>
                    <p v-if="writeback_administrative_block" 
                        class="alert alert-danger">{{ writeback_administrative_block_message }} </p>
                </template>    
                
                <template v-if='can_copy_to_record_system && showwritebackuser && is_originating_provider && has_record_system_integration()'>
                    <div class="form-group">
                        <label for='name'>{{ autobrand('translations.when_transferred_request_completes_automatically_writeback')}}:</label>
                        <select class='form-control' v-model='thread.thread_provider.writeback_user_id'>
                            <option :value="null">-- {{ $t('translations.do_not_automatically_writeback')}} --</option>
                            <template v-for='(user) in $root.lookup.staff'>
                                <option v-if='user.provider.mrs_user_id' :key='user.id' :value='user.id'>
                                    {{ formatNameCompliant(user) }}
                                </option>
                            </template>
                        </select>
                    </div>
                </template>

                <template v-if='!showwritebackuser || !thread.thread_provider.writeback_user_id'>
                    <label>{{ $t('translations.consultation')}}: </label>
                    <textarea ref='copyTextArea' style='min-width: 100%; height: 200px' class='mb-1' v-model='copy_content'></textarea>
                    <div class='form-group'>
                        <label for='include_internal_messages'>
                            <input type='checkbox' id='include_internal_messages' v-model='include_internal_messages'>
                            {{ $t('translations.include_internal_messages')}}
                        </label>
                    </div>
                </template>
                
                
                <template v-if='originating_provider_has_user_record_system_integration || has_record_system_integration()'>
                    <label>{{ $t('translations.codes')}}: </label>
                    <coding-list class='mb-1' :editable='(originating_provider_has_user_record_system_integration || has_user_record_system_integration) && !thread.archived' :value='codes' :errors='errors' />
                    <label>{{ $t('translations.blood_pressure')}}: </label>
                    <blood-pressure-list class='mb-1' :editable='(originating_provider_has_user_record_system_integration || has_user_record_system_integration) && !thread.archived' :value='blood_pressures' :errors='errors' />
                </template>
                
                

                
                <!-- ATTACHMENTS FOR THE COPY DIALOG -->
                <label v-show='haveAttachments'>{{ $t('translations.attachments')}}: </label>
                <p v-if='((image_data && image_data.length) || (document_data && document_data.length)) && has_user_record_system_integration && can_copy_to_record_system && !thread.archived'> {{$t('translations.attachments_auto_copy_to_record_system')}}</p>

                <div class='d-flex flex-wrap align-items-end'>
                    <div :key='"attachments-" + item.id' v-for="(item) in messages">
                        <attachment-display v-if='(item.message_image && item.message_image.length)
                                        || (item.message_document && item.message_document.length)'
                                :in_images='item.message_image' 
                                :in_documents='item.message_document' 
                                :allow_delete='false' 
                                :show_images='false' 
                                :show_image_names='true' 
                                :owner='thread' 
                                :in_image_data='image_data' 
                                :in_document_data='document_data' 
                                in_api_load_prefix='message' 
                                :show_download='!has_user_record_system_integration || !can_copy_to_record_system || thread.archived' 
                                :show_selector='true'
                                v-on:selected-image-update='selected_image_update($event)'
                                v-on:selected-document-update='selected_document_update($event)' />
                            
                        
                        <template v-if='item.form_submission && item.form_submission.length'>
                            <template v-if='item.form_submission[0].submitted_at'>
                                <attachment-display v-if='(item.form_submission[0].form_submission_image && item.form_submission[0].form_submission_image.length)
                                        || (item.form_submission[0].form_submission_document && item.form_submission[0].form_submission_document.length)'
                                    :in_images='item.form_submission[0].form_submission_image' 
                                    :in_documents='item.form_submission[0].form_submission_document' 
                                    :allow_delete='false' 
                                    :show_images='false' 
                                    :show_image_names='true' 
                                    :owner='thread' 
                                    :in_image_data='image_data' 
                                    :in_document_data='document_data'
                                    in_api_load_prefix='formsubmission' 
                                    :show_download='!has_user_record_system_integration || !can_copy_to_record_system || thread.archived'
                                    :show_selector='true'
                                    v-on:selected-image-update='selected_image_update($event)'
                                    v-on:selected-document-update='selected_document_update($event)' />
                            </template>
                        </template>  
                    </div>
                </div>
            </div>
        </div>
        <!-- <img :width='full_image.width' :height='full_image.height' style='max-width: 100%; max-height: 100%;' :src='full_image.data'> -->
        <div slot="modal-footer" class="w-100">
            <div class='d-flex justify-content-end'>
                <template v-if='this.filing.filing_status_id == 2'>
                    <b-btn size="sm" class="m-1 copy_to_clipboard" variant="light" v-on:click.prevent='copyText(); hide();'>
                            {{ $t("translations.copy_to_clipboard") }}
                    </b-btn>
                    <b-btn size="sm" class="m-1 mr-auto" variant="light" v-on:click.prevent='clearStatus(); hide();'>
                            {{ $t("translations.mrs_clear_status") }}
                    </b-btn>
                </template>
                
                <b-btn size="sm" class="m-1" variant="primary" v-on:click.prevent='$refs.copyDialog.hide();'>
                    {{ $t(canceltext) }}
                </b-btn>
                <template v-if='showwritebackuser && thread.thread_provider.writeback_user_id'>
                    <b-btn size="sm" class="m-1" variant="primary" v-on:click.prevent='updateCodes()'>
                        {{ $t(actiontextwb) | capitalise }}
                    </b-btn>
                </template>
                <template v-else>
                    <b-btn v-if='showskip' size="sm" class="m-1" variant="primary" v-on:click.prevent='hide();'>
                        {{ $t(skiptext) }}
                    </b-btn>
                    <template v-if='this.filing.filing_status_id != 3 && this.filing.filing_status_id != 999'>
                        
                        <b-btn v-if='allowotherwriteback && originating_provider_has_user_record_system_integration && can_copy_to_record_system && !thread.archived' size="sm" class="m-1" variant="primary" v-on:click.prevent='validate()'>
                                {{ $t(actiontextrso) }}
                        </b-btn>
                        
                        <b-btn v-else-if='has_user_record_system_integration && is_originating_provider && can_copy_to_record_system && !writeback_administrative_block && !thread.archived' size="sm" class="m-1" variant="primary" v-on:click.prevent='validate()'>
                                {{ $t(actiontextrs) }}
                        </b-btn>
                        
                        <b-btn v-else size="sm" class="m-1 copy_to_clipboard" variant="primary" v-on:click.prevent='copyText(); hide();'>
                                {{ $t(actiontext) }}
                        </b-btn>
                    </template>
                </template>
            </div>
        </div>
    </b-modal>

    <!-- <div class="modal fade" ref="copyDialogx" tabindex="-1" role="dialog" aria-labelledby="filterModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog filter-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Request Details</h5>
                </div>
                <div class="modal-body">
                        <div>
                            <textarea ref='copyTextAreax' style='min-width: 100%; min-height: 50vh' v-text='copy_content'></textarea>
                        </div>

                        <div class="d-flex">
                            <button class="btn btn-success ml-auto" v-on:click.prevent='copyText' data-dismiss="modal">Copy</button>
                        </div>

                </div>
            </div>
        </div>
    </div> -->


</template>


<script>

	export default {
        extends: app.base.attachmentHelper,
		props: {
            thread: {},
            messages: {},
            actiontext: {
                default: 'translations.copy_to_clipboard'
            },
            actiontextrs: {
                default: 'translations.copy_rs'
            },
            actiontextwb: {
                default: 'translations.copy_to_clipboard'
            },
            actiontextrso: {
                default: 'translations.copy_rso'
            },
            canceltext: {
                default: 'translations.cancel'
            },
            skiptext: {
                default: 'translations.skip'
            },
            cachedimagedata: {
                default: function () {
                    return []
                },
            },
            cacheddocumentdata: {
                default: function () {
                    return []
                },
            },
            copymessage: null,
            showskip: {
                default: false,
            },
            validateonly: {
                default: false,
            },
            showwritebackuser: {
                default: false,
            },
            allowotherwriteback: {
                default: false,
            }
		},
		data: function(){
			return {
                filing: {},
                shown: false,
                copy_content: "",
                failed: false,
                mutable_copy_message: this.copymessage,
                selected_documents: [],
                selected_images: [],
                codes: [],
                blood_pressures: [],
                strip_codes: true,
                errors: [],
                include_internal_messages: true,
                custom_action: {},
                originating_provider_has_user_record_system_integration: false,
                pending_writeback_administrative_block_hours: 96,
                successful_writeback_administrative_unblock_hours: 1,
                writeback_administrative_block: false,
                writeback_administrative_block_message: "",
			};
		},
		computed: {
            can_copy_to_record_system() {
                return this.thread && this.thread.user && this.thread.user.nhs_number;
            },
            has_user_record_system_integration() {
                return this.failed == false 
                    && this.$root.provider.record_system_integration_type_id == 1 
                    && this.$root.user.provider.mrs_user_id;
                    // && (!this.$root.provider.record_system_test_user_id || this.$root.provider.record_system_test_user_id == this.$root.user.id);
            },
            is_originating_provider() {
                return this.$root.provider.id == this.thread.originating_provider_id;
            },
		},
		watch: {
            include_internal_messages() {
                this.updateCopyContent();
            }
		},
		created() {
        },
		beforeDestroy() {
		},
		mounted() {
            this.image_data = 
                this.cachedimagedata;
            //console.warn(this.cacheddocumentdata);
            this.document_data = 
                this.cacheddocumentdata;
		},

		methods: {
            copyText() {
                //this.copyElementText(this.$refs.copyTextArea);
				this.$refs.copyTextArea.focus();
				this.$refs.copyTextArea.select();
				document.execCommand("copy");
                this.addNotification({type: "success", content: this.capitalise(this.autobrand('translations.request_copied_to_clipboard'))});
			},
            hide() {
                this.$refs.copyDialog.hide();
                if(this.validateonly) {
                    this.$emit('skip-copy');
                }
            },
            getAttachmentLinks(index) {
                for(var image_index = 0; image_index < this.messages[index].message_image.length; image_index++) {
                    this.copy_content += " [attachment: " + (this.messages[index].message_image[image_index].image.name ? this.messages[index].message_image[image_index].image.name : this.getShortImageDownloadName(this.thread, this.messages[index].message_image[image_index].image_id)) + "]";
                }
                for(var document_index = 0; document_index < this.messages[index].message_document.length; document_index++) {
                    this.copy_content += " [attachment: " + this.messages[index].message_document[document_index].document.name + "]";
                }
            },
            formatMessage(index, show_time = false, show_meta = false, text = null) {
                if(this.$root.provider.include_datetime_when_copying && show_time) {
                    this.copy_content += "[" + this.formatDateTime(this.messages[index].created_at) + "] ";
                }
                if(show_meta) {
                    this.copy_content += "(" + this.formatNameWithProvider(this.messages[index].user, this.messages[index].provider, this.thread, this.messages) + ") ";
                
                    if(this.messages[index].internal) {
                        this.copy_content += "("+ this.$t('translations.internal_note') + ") ";
                    }
                    else if(!this.is_patient(this.messages[index].user)) {
                        this.copy_content += "(" + this.autobrand('translations.message_to_patient') +") ";
                    }
                }

                
                if(text) {
                    this.copy_content += text;
                }
                else {
                    this.copy_content += this.messages[index].message;
                }
                this.getAttachmentLinks(index);
                this.copy_content += "\n";
            },
            updateCopyContent() {
                //console.warn('document_data', this.document_data);
                // this.image_data.forEach((obj, index) => {
                //     if(!obj["data"]) {
                //         this.$set(this.image_data[index], "data", null);
                //     }
                // });

                // this.document_data.forEach((obj, index) => {
                //     if(!obj["data"]) {
                //         this.$set(this.document_data[index], "data", null);
                //     }
                // })
                
				//this.copy_content = this.formatNameCompliant(this.thread.user) + " ";
				this.copy_content = this.thread.user.surname.toUpperCase() + ", " + this.thread.user.forenames + " ";
				//this.copy_content += "Born: " + this.formatDate(this.thread.user.dob) + " (" + Vue.options.filters.getAge(this.thread.user.dob) + "y)  ";
				this.copy_content += this.formatDate(this.thread.user.dob) + "\n"
				this.copy_content += this.tBrandKey("app_name") + " " + this.$route.params.id + "\n";
				//this.copy_content += "Gender: " + this.getGender(this.thread.user.gender) + "  ";
                if(this.thread.user.nhs_number) {
                    this.copy_content += "NHS/CHI No. " + this.thread.user.nhs_number.replace(/(.{3})/,'$1 ').replace(/(.{7})/,'$1 ') + "\n";
                }
				//this.copy_content += "\n";
				//this.copy_content += "askmyGP"


				if(this.messages && this.messages.length) {
					if (this.messages.filter((obj) => {
						return obj.question_id != null;
					}).length > 0) {
						//this.copy_content += "\n";

						for(var item in this.messages) {
							if(this.messages[item].question_id) {
								//this.copy_content += this.messages[item].question.short_content + ": " + this.messages[item].message + "\n";
							}
						}
						//this.copy_content += "\n";
					}

					// Get the subject
					for (var index in this.messages) {
						if(this.messages[index].question && this.messages[index].question.is_subject) {
							this.copy_content += this.autobrand('translations.history_from_patient') + ": \n";
                            this.formatMessage(index);
						}
					}



					// Show thread answer where short_content === "Symptoms/Cause/Concerns/Expectations"
					for (var index in this.messages) {
                        if(this.messages[index].question) {
                            if (this.$t('qa.' + this.messages[index].question.short_content) === this.$t('qa.sc_how_long')) {
                                this.formatMessage(index);
                            }
                            // for new Medical Problem.
                            else if(this.$t('qa.' + this.messages[index].question.short_content) === this.$t('qa.sc_symptoms')) {
                                this.formatMessage(index);
                            }
                            // for Exisiting Problem route.
                            else if(this.$t('qa.' + this.messages[index].question.short_content) === this.$t('qa.sc_changes')) {
                                this.formatMessage(index);
                            }
                            // for Other Question route.
                            else if(this.$t('qa.' +this.messages[index].question.short_content) === this.$t('qa.sc_explain_question')) {
                                this.formatMessage(index);
                            }
                            // for Medication Query route.
                            else if(this.$t('qa.' +this.messages[index].question.short_content) === this.$t('qa.sc_explain_medication_query')) {
                                this.formatMessage(index);
                            }

                            //console.info(this.$t('qa.' +this.messages[index].question.short_content), this.$t('qa.sc_explain_medication_query'));
                        }
					}
                    this.codes = this.copyNonReactive(this.thread.thread_code);
                    this.blood_pressures = this.copyNonReactive(this.thread.blood_pressure);
					// Get everything else
					for(var index in this.messages) {
						if(!this.messages[index].question && !this.messages[index].automated && (this.include_internal_messages || !this.messages[index].internal)) {
							
							
                            this.formatMessage(index, true, true);

                            if(this.messages[index].form_submission && this.messages[index].form_submission[0]) {
                                this.copy_content += "  " + this.getFormTitle(this.messages[index].form_submission[0]) + "\n";
                                this.copy_content += "  " + (this.messages[index].form_submission[0].submitted_at ? "Form submitted at " + this.formatDateTime(this.messages[index].form_submission[0].submitted_at) : "Partial form submitted") + " by " + this.formatNameWithProvider(this.messages[index].form_submission[0].user, this.messages[index].provider, this.messages[index].thread, this.messages) + "\n";
                                //item in JSON.parse(this.messages[index].form_submission[0].content).readable
                                var form_content = JSON.parse(this.messages[index].form_submission[0].content);
                                if(form_content && form_content.readable) {
                                    for(var [key, value] of Object.entries(this.getPlainAnswers(this.messages[index].form_submission[0], form_content))) {
                                        if(this.strip_codes) {
                                            this.copy_content += "  * " + (value.plain_head + " " + value.plain_body).replace(/ *(___(AMG.*?)(?=___)___[, ]*)+/g, "").replace(/[([][)\]]/,"") + "\n"
                                            
                                        }
                                        else {
                                            this.copy_content += "  * " + value.plain_head + " " + value.plain_body + "\n"
                                        }
                                    }
                                }
                            }
						}
					}
                }
                this.selected_documents = [];
                this.selected_images = [];
                for(var message_index = 0; message_index < this.messages.length; message_index++) {
                    this.api_load_prefix = "message";

                    for(var image_index = 0; image_index < this.messages[message_index].message_image.length; image_index++) {
                        this.loadImageData(this.messages[message_index].message_image[image_index].image_id, this.thread.archived);
                        //this.selected_images.push(this.messages[message_index].message_image[image_index].image_id);
                
                
                    }
                    for(var document_index = 0; document_index < this.messages[message_index].message_document.length; document_index++) {
                        this.loadDocumentData(this.messages[message_index].message_document[document_index].document, this.thread.archived);
                        //this.selected_documents.push(this.messages[message_index].message_document[document_index].document_id);
                    }
                    
                    this.api_load_prefix = "formsubmission";

                    for(var form_index = 0; form_index < this.messages[message_index].form_submission.length; form_index++) {
                        for(var image_index = 0; image_index < this.messages[message_index].form_submission[form_index].form_submission_image.length; image_index++) {
                            this.loadImageData(this.messages[message_index].form_submission[form_index].form_submission_image[image_index].image_id, this.thread.archived);
                            //this.selected_images.push(this.messages[message_index].form_submission[form_index].form_submission_image[image_index].image_id);
                    
                    
                        }
                        for(var document_index = 0; document_index < this.messages[message_index].form_submission[form_index].form_submission_document.length; document_index++) {
                            this.loadDocumentData(this.messages[message_index].form_submission[form_index].form_submission_document[document_index].document, this.thread.archived);
                            //this.selected_documents.push(this.messages[message_index].form_submission[form_index].form_submission_document[document_index].document_id);
                        }
                    }
                }
                
                try{
                    // If the string is UTF-8, this will work and not throw an error.
                    this.copy_content = decodeURIComponent(escape(this.copy_content));
                }
                catch(e) {
                    // If it isn't, an error will be thrown, and we can assume that we have an ISO string already.
                }
                this.copy_content = this.copy_content.replace(/[^\r\n\t\f -\u00AF]+/gu, "");
            },

            // @todo Why isn't this a computed property?
            process_originating_provider_writeback() {

                var originating_provider_xref = this.thread.thread_provider_xref.find(obj => {return obj.provider_id == this.thread.originating_provider_id});
                this.originating_provider_has_user_record_system_integration = false;

                // Look for an originating provider with writeback request in the xref first
                if(originating_provider_xref && originating_provider_xref.provider_id != this.$root.user.provider.id
                        && originating_provider_xref.writeback_user_id) {
                    this.originating_provider_has_user_record_system_integration = true;
                }
                
                // @todo We can probably remove this final case altogether at some point. We copy the writeback_user_id
                //   in to the thread_provider_xrefs table, so we shouldn't need to refer back to the custom_action,
                //   and in fact Dan found a bug based on this, so I've commented it out for now.

                // otherwise if this is a custom action, look for the writeback_user_id in the custom action.
                // else if(this.messages[0] 
                //         && this.messages[0].form_submission.length
                //         && this.messages[0].form_submission.length
                //         && this.messages[0].form_submission[0].custom_action) {
                //     this.custom_action = this.messages[0].form_submission[0].custom_action;
                //     if(this.custom_action.provider_id != this.$root.user.provider.id 
                //             && this.custom_action.writeback_user_id) {
                //         this.originating_provider_has_user_record_system_integration = true;
                //     }

                // }
                    
            },
			show(transfer = false) {
                // We need to keep track of this window when it is "showing" not just shown,
                // so we can't rely on the shown state of the b-modal's v-model. This is because
                // of the time it can take to show, and that we might receive a "close" message
                // for the thread triggered elsewhere in the system which causes the window
                // to close when we are actually still waiting for network events in this "show"
                // function.
                this.shown = true;
                
                this.mutable_copy_message = this.copymessage;
                this.failed = false;
                this.errors = [];
                this.include_internal_messages = this.$root.provider.default_include_internal_message;
                
                this.updateCopyContent();
                
                this.process_originating_provider_writeback();
                
                if(this.can_copy_to_record_system && !this.thread.archived) {
                    this.checkPendingFilingStatus().then(() => {
                        if(this.has_user_record_system_integration) {
                            this.$root.setLoading(true);
                            // @todo Do we need a special version of the show() for Filings? When the filing you are actually
                            // interested in belongs to originator, not to the logged in user?
                            // I think we do, although the chances of a filing being in the queue when a transferee completes are
                            // zero currently, but it's still not technically correct here.
                            return axios.get(this.$root.apiBase + '/filing/' + this.thread.id).then((res) => {
                                this.filing = res.data.filing;
                                switch(this.filing.filing_status_id) {
                                    case 1: 
                                        this.mutable_copy_message = this.autobrand('translations.mrs_already_copied_successfully_id', {id: this.filing.filing_request_id});
                                        break;
                                    case 2:
                                        if(this.filing.filing_request_id) {
                                            this.mutable_copy_message = this.autobrand('translations.mrs_failed_previous_id', {id: this.filing.filing_request_id});
                                        }
                                        else {
                                            this.mutable_copy_message = this.autobrand('translations.mrs_failed_previous');
                                        }
                                        if(this.filing.message) {
                                            this.mutable_copy_message += " " + this.$t('translations.mrs_failed_reason') + " " + this.filing.message;
                                        }
                                        break;
                                    case 3:
                                    case 999:
                                        if(this.filing.filing_request_id) {
                                            this.mutable_copy_message = this.$t('translations.mrs_copy_pending_already_id', {id: this.filing.filing_request_id});
                                        }
                                        else {
                                            this.mutable_copy_message = this.$t('translations.mrs_copy_pending_already');
                                        }
                                        break;
                                }
                                this.$root.setLoading(false);
                                this.$refs.copyDialog.show();
                            }).catch((error) => {
                                this.$root.setLoading(false);
                                this.$refs.copyDialog.show();
                            });
                        }
                        else {
                            this.$root.setLoading(false);
                            this.$refs.copyDialog.show();
                        }
                    });
                }
                else {
                    this.$refs.copyDialog.show();
                }
            },

            initCopySelect(event) {
                this.$refs.copyTextArea.focus();
				this.$refs.copyTextArea.select();
			},
			hideCopy() {
                this.$refs.copyDialog.hide();
			},
            validate() {
                if(this.validateonly) {
                    return axios.put(this.$root.apiBase + '/mrs/validate', {
                            "thread_id": this.thread.id,
                            "text": this.copy_content,
                            "selected_images": this.selected_images,
                            "selected_documents": this.selected_documents,
                            "codes": this.codes,
                            "blood_pressures": this.blood_pressures,
                    }).then((res) => {
                        this.$root.setLoading(false);
                        this.$emit("validated-copy");
                        this.hideCopy();
                        return true;
                    }).catch((error) => {
                        this.$root.setLoading(false);
                        this.handleError(error, "copy");
                        if (error.response.status === 422) {
                            
                        } else {
                            var message = this.$t('translations.mrs_failed');
                            if(error.response && error.response.data && error.response.data.message) {
                                message += " " + this.$t('translations.mrs_failed_reason') + " " + error.response.data.message;
                            }
                            this.mutable_copy_message = message;
                            //this.addNotification({timeout: 10000, type: "warning", content: message});
                            this.failed = true;  
                        }
                                        
                    });
                }
                else {
                    // The copy also does validation. We only want to split validation when we are in a chain (for example: Assign/Copy/Share)
                    this.copyToRecordSystem(); 
                }
            },
            copyToRecordSystem() {
                this.$root.setLoading(true);
                this.errors = [];
                return axios.put(this.$root.apiBase + '/mrs', {
                        "thread_id": this.thread.id,
                        "text": this.copy_content,
                        "selected_images": this.selected_images,
                        "selected_documents": this.selected_documents,
                        "codes": this.codes,
                        "blood_pressures": this.blood_pressures,
                }).then((res) => {
                    this.thread.filing_request_id = res.data.messageId;
                    this.$root.setFailedFilingCount(res.data.failed_filings_per_user);
                    this.$root.setLoading(false);
                    this.$emit("copied-to-mrs");
                    //this.addNotification({type: "success", content: this.$t('translations.mrs_copied_successfully', {"id": res.data.messageId})});
                    this.addNotification({type: "success", content: this.$t('translations.mrs_copy_initiated')});
                    this.hideCopy();
                }).catch((error) => {
                    this.$root.setLoading(false);
                    this.handleError(error, "copy");
                    if (error.response.status === 422) {
                        
                    } else {
                        var message = this.$t('translations.mrs_failed');
                        if(error.response && error.response.data && error.response.data.message) {
                            message += " " + this.$t('translations.mrs_failed_reason') + " " + error.response.data.message;
                        }
                        this.mutable_copy_message = message;
                        //this.addNotification({timeout: 10000, type: "warning", content: message});
                        this.failed = true;  
                    }
                                      
                });
            },
            updateCodes() {
                this.$root.setLoading(true);
                this.errors = [];
                return axios.put(this.$root.apiBase + '/threads/updateCodes/' + this.thread.id, {
                        "codes": this.codes,
                        "blood_pressures": this.blood_pressures,
                }).then((res) => {
                    this.$root.setLoading(false);
                    this.$emit("skip-copy");
                    this.hideCopy();
                    return true;
                }).catch((error) => {
                    this.$root.setLoading(false);
                    this.handleError(error, "copy");
                    return false;
                });
            },
            clearStatus() {
                this.$root.setLoading(true);
                return axios.delete(this.$root.apiBase + '/filing/' + this.thread.id).then((res) => {
                    this.$root.setLoading(false);
                    this.$emit("cleared");
                    this.hideCopy();
                    return true;
                }).catch((error) => {
                    this.$root.setLoading(false);
				    this.handleError(error, "delete");
                });
            },
            selected_document_update(e) {
                if(e.checked == false) {
                    var index = this.selected_documents.findIndex(obj => {return obj == e.id});
                    if(index != -1) {
                        this.selected_documents.splice(index, 1);
                    }
                }
                else {
                    this.selected_documents.push(e.id);
                }
            },
            selected_image_update(e) {
                if(e.checked == false) {
                    var index = this.selected_images.findIndex(obj => {return obj == e.id});
                    if(index != -1) {
                        this.selected_images.splice(index, 1);
                    }
                }
                else {
                    this.selected_images.push(e.id);
                }
            },
            checkPendingFilingStatus() {
                this.writeback_administrative_block = false;
                this.writeback_administrative_block_message = "";
                if(
                    (this.is_originating_provider && this.has_user_record_system_integration)
                    || (!this.is_originating_provider && this.originating_provider_has_user_record_system_integration)
                ) {
                    return axios.get(`${this.$root.apiBase}/filing/status/${this.thread.originating_provider_id}`).then((res) => {
                        if(res.data) {
                            if((!res.data.latest_successful_filing || this.moment().diff(this.moment(res.data.latest_successful_filing), "hours") > this.successful_writeback_administrative_unblock_hours) 
                                    && this.moment().diff(this.moment(res.data.oldest_pending_filing), "hours") > this.pending_writeback_administrative_block_hours) {
                                this.writeback_administrative_block = true;
                                if(this.is_originating_provider) {
                                    this.writeback_administrative_block_message = this.autobrand('errors.writeback_admin_block', {"hours": this.pending_writeback_administrative_block_hours});
                                }
                                else {
                                    this.writeback_administrative_block_message = this.autobrand('errors.writeback_admin_block_originator'
                                        , {
                                            "hours": this.pending_writeback_administrative_block_hours,
                                            "provider_name": this.thread.originating_provider.name
                                        });
                                }
                            }
                            
                        }
                        //setTimeout(this.checkPendingMaxAge, 1000 * 60 * 60 * 2);
                        //setTimeout(this.checkPendingMaxAge, this.checkPendingMaxAgeTimeout);
                    });
                }
                else {
                    return Promise.resolve();
                }
            },
            getFormTitle(form_submission) {
                if(form_submission.form_version) {
                    return form_submission.form_version.title;
                }
                else if(form_submission.form_submission_form) {
                    return form_submission.form_submission_form.title;
                }
                
            }
		}
    }
</script>
